(function() {
	'use strict';

	angular
		.module('smb-app')
		.factory('smbDocumentViewerNavigationService', [
			'$state', 
			'$q',
			DocumentViewerNavigationService
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentViewerNavigationService
	 *
	 * @description
	 * Small service that provides a convience method for navigating to
	 * the document viewer.
	 */
	function DocumentViewerNavigationService($state, $q) {
		var _previousState;
		var _previousStateParams;

		var _defaultState = 'content.home';

		return {
			go: go,
			back: back,

			get backState() { return _previousState ? _previousState.name : _defaultState; },

			get backStateParams() { return _previousStateParams; }
		};

		function go(documentGroupId, documentTypeId, documentId) {
			_previousState = $state.current;
			_previousStateParams = $state.params || null;

			$state.go('document.view', {
				documentGroupId: documentGroupId,
				documentTypeId: documentTypeId,
				documentId: documentId
			});
		}

		function back() {
			var p = $q.reject(new Error('No applicable previous state.'));
			if (_previousState) {
				p = _previousStateParams ? 
					$state.go(_previousState.name, _previousStateParams) :
					$state.go(_previousState.name);				
			} else if(angular.isDefined($state.params.documentGroupId) && angular.isDefined($state.params.documentTypeId)) {
				// default to document type group search
				p = $state.go('search.contentTypeGroups.contentTypes.search', {
					groupId: $state.params.documentGroupId,
					typeId: $state.params.documentTypeId
				});
			}

			return p;
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/documentViewerNavigationService.js
// module id = 151
// module chunks = 1